export function Footer() {
  return (
    <footer className="ap-footer">
      <span>© {new Date().getFullYear()} NESTRA</span>
      <span className="ap-footer__sep">·</span>
      <span>All rights reserved</span>
    </footer>
  );
}
